import React, { useMemo, useState } from 'react';
import {
  IChannelLanguagePerformance,
  IRealtimeCommunityType,
  IRealtimeOpinionsTabType,
  IRealtimeOrganizationType,
} from '../../type';
import { FilterFixed, useFilterDataHook } from '@op/components/FilterCommon';
import { DBO_TM } from '@op/utils/format';
import CardCommon from '@op/components/CardCommon';
import ChannelLanguageChart from '../../component/ChannelLanguageChart';
import {
  METRICS_LIST,
  REALTIME_CHANNEL_ACCOUNT_OPTIONS,
  REALTIME_CHANNEL_TYPE_OPTIONS,
  REALTIME_TAB_OPTIONS,
} from '../../constant';
import { reviewsFormat } from '@op/utils/value';
import { Segment } from 'tea-component';
import { getSegmentWithIcon } from '../../utils';
import useLanguage from '@op/hooks/useLanguage';
import { useRealtimeRefresh } from '../../hook';
import { AppContext } from '../KeyMetricsOverview/context';

const LanguagePerformance = (props: IChannelLanguagePerformance) => {
  const { gameInfo } = props;
  const {
    scrollBody,
    loading: filterLoading,
    filter,
    changeFilter,
    filterOptions,
    confirmRef,
  } = useFilterDataHook({
    gameInfo,
    pageName: 'Key_Metrics',
  });
  const [organization, setOrganization] =
    useState<IRealtimeOrganizationType>('all');
  const [reviewTypes, setReviewTypes] =
    useState<IRealtimeCommunityType>('total');
  const [deadline, setDeadline] = useState<IRealtimeOpinionsTabType>('current');
  const { formatOptionsMessage, formatMessage } = useLanguage();
  const isToday = useMemo(
    () => (filterLoading ? false : DBO_TM.isToday(filter)),
    [filter, filterLoading],
  );
  const { refresh, setRefresh, resetInterval, refreshTime, setRefreshTime } =
    useRealtimeRefresh(isToday);

  const metricsList = useMemo(() => METRICS_LIST.language, []);

  return (
    <>
      <FilterFixed
        scrollBody={scrollBody}
        filter={filterOptions}
        confirmRef={confirmRef}
        defaultValue={DBO_TM.utcFilterRangeDay(0, 0)}
        confirm={(value: any) => {
          changeFilter({ ...value, ...gameInfo });
          resetInterval();
        }}
        defaultConfig={{
          date: {
            isSingleDay: true,
          },
        }}
      ></FilterFixed>
      <CardCommon
        className="dbo-realtime-channel-language-performance"
        contentCard
        loading={filterLoading}
        loadingHeight={1000}
        title={
          <div className="dbo-realtime-channel-language-performance-segment-tab">
            <Segment
              className="segment-light segment-font12"
              value={reviewTypes}
              onChange={(value: IRealtimeCommunityType) => {
                setReviewTypes(value);
              }}
              options={getSegmentWithIcon(
                REALTIME_CHANNEL_TYPE_OPTIONS.filter(
                  (val) => val.value !== 'stream',
                ),
                formatMessage,
              )}
            />
            {reviewTypes !== 'stream' && (
              <Segment
                className="segment-light segment-font12"
                value={organization}
                onChange={(value: IRealtimeOrganizationType) => {
                  setOrganization(value);
                }}
                options={formatOptionsMessage(REALTIME_CHANNEL_ACCOUNT_OPTIONS)}
              />
            )}
            {isToday && (
              <Segment
                className="segment-light segment-font12"
                value={deadline}
                onChange={(value: IRealtimeOpinionsTabType) => {
                  setDeadline(value);
                }}
                options={formatOptionsMessage(REALTIME_TAB_OPTIONS, undefined, {
                  placement: 'top',
                  style: { maxWidth: 220 },
                })}
              />
            )}
          </div>
        }
      >
        <AppContext.Provider
          value={{ refresh, setRefresh, refreshTime, setRefreshTime }}
        >
          {metricsList.map((val: any, index) => {
            const {
              title,
              value,
              format = reviewsFormat,
              isPercent,
              isAvg,
            } = val;
            return (
              <>
                <ChannelLanguageChart
                  gameInfo={gameInfo}
                  title={title}
                  key={index}
                  metrics={value}
                  formatValue={format}
                  filter={filter}
                  isPercent={isPercent}
                  isAvg={isAvg}
                  type={'language'}
                  reviewTypes={reviewTypes}
                  organization={organization}
                  deadline={deadline}
                />
              </>
            );
          })}
        </AppContext.Provider>
      </CardCommon>
    </>
  );
};

export default LanguagePerformance;
